import dayjs from 'dayjs';
import { useWorkScheduleQuery } from '../../../profile/work-schedule/hooks';
import { DEFAULT_WEEKLY_SCHEDULE } from '../../schedule/entity';

export const useWorkingHours = (date: Date | undefined) => {
  const targetDate = date ? dayjs(date) : dayjs();
  const { data: workScheduleData } = useWorkScheduleQuery(
    targetDate.year(),
    targetDate.month() + 1,
  );

  if (!date) {
    return { start: '08:00', end: '18:00' };
  }

  const defaultValuesWorkingSchedule = {
    weeklySchedule: workScheduleData?.schedule?.weeklySchedule || DEFAULT_WEEKLY_SCHEDULE,
    holidays: workScheduleData?.schedule?.holidays || [],
  };

  const selectedDate = dayjs(date);
  const dayOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][
    selectedDate.day()
  ] as keyof typeof DEFAULT_WEEKLY_SCHEDULE;

  const isHoliday = defaultValuesWorkingSchedule.holidays?.some(holiday => {
    const holidayDate = dayjs(holiday.date);

    return holidayDate.format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD');
  });

  if (isHoliday) {
    return undefined;
  }

  const daySchedule = defaultValuesWorkingSchedule.weeklySchedule?.[dayOfWeek];

  if (!daySchedule?.isWorking || !daySchedule.timeSlots?.length) {
    return undefined;
  }

  const firstSlot = daySchedule.timeSlots[0];

  return {
    start: firstSlot.start,
    end: firstSlot.end,
  };
};
